export const SIGN_IN_PATH = '/sign-in'
export const RETURN_TO_PARAM = 'returnTo'
export const CHANGE_PASSWORD_PATH = '/change-password'

export function getCurrentReturnTo() {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`
}

export function getSignInUrl(returnTo = getCurrentReturnTo()) {
  return `${SIGN_IN_PATH}?${RETURN_TO_PARAM}=${encodeURIComponent(returnTo)}`
}

export function getSafeReturnTo(search: string) {
  const returnTo = new URLSearchParams(search).get(RETURN_TO_PARAM)
  return returnTo?.startsWith('/') && !returnTo.startsWith('//') && returnTo !== CHANGE_PASSWORD_PATH ? returnTo : '/'
}
